import {
    fetchCurrentUser as _fetchCurrentUser,
    fetchArchiveLocations as _fetchArchiveLocations,
    fetchMyArchiveLocations as _fetchMyArchiveLocations,
    fetchMediaList as _fetchMediaList,
    login as _login,
    logout as _logout,
} from "../../../utils/api";

export const fetchCurrentUser = () => _fetchCurrentUser();

export const login = async (form) => {
    try {
        const res = await _login(form);
        return res;
    } catch (err) {
        const msg = err.response?.data?.message || err.response?.data?.error || "ログインに失敗しました";
        throw new Error(msg);
    }
};

export const logout = () => _logout();

export const fetchMyArchiveLocations = (projectId, params = {}) =>
    _fetchMyArchiveLocations(projectId, params);

export const fetchArchiveLocations = (projectId, params = {}) =>
    _fetchArchiveLocations(projectId, params);

export const fetchMediaList = (locationId) =>
    _fetchMediaList(locationId);

